import { Branch, BranchLocation } from '../types/location';
import { USStates } from '../constants/states';
import { getStateFullName } from './location';

// location-finder API response types
export interface BranchFinderGeoLocation {
  street: string;
  city: string;
  region: string;
  state: string;
  latitude: number;
  longitude: number;
  postal_code: string;
  get_directions_link: string;
  dma: string;
  population_center: string | null;
  distance_miles: number;
}

export interface BranchFinderHours {
  text: string;
  open: string | null;
  close: string | null;
}

export interface BranchFinderBusinessHours {
  monday: BranchFinderHours;
  tuesday: BranchFinderHours;
  wednesday: BranchFinderHours;
  thursday: BranchFinderHours;
  friday: BranchFinderHours;
  saturday: BranchFinderHours;
  sunday: BranchFinderHours;
}

export interface BranchFinderRentalService {
  name: string;
  paragraph: string;
  rich_text_content: string;
  slug: string;
  sort_order: number;
}

export interface BranchFinderMarket {
  market_id: number;
  phone: string;
  solution: {
    name: string;
    sort_order: number;
  };
  delivery_radius_miles: number;
  rental_services: BranchFinderRentalService[];
}

export interface BranchFinderLocation {
  name: string;
  slug: string;
  phone: string;
  url: string;
  description: string;
  geo: BranchFinderGeoLocation;
  hours: BranchFinderBusinessHours;
  markets: BranchFinderMarket[];
}

export const mapBranchFinderLocationToBranch = (
  location: BranchFinderLocation,
  market: BranchFinderMarket,
  rentalService: BranchFinderRentalService,
): Branch | null => {
  if (!market.market_id || !rentalService.slug) {
    return null;
  }

  const branchLocation: BranchLocation = {
    about_equipmentshare_header: location.name,
    about_equipmentshare_text: location.description,
    city: location.geo.city,
    description: location.description,
    get_directions_link: location.geo.get_directions_link,
    hours_of_operation_friday: location.hours.friday.text,
    hours_of_operation_monday: location.hours.monday.text,
    hours_of_operation_saturday: location.hours.saturday.text,
    hours_of_operation_sunday: location.hours.sunday.text,
    hours_of_operation_thursday: location.hours.thursday.text,
    hours_of_operation_tuesday: location.hours.tuesday.text,
    hours_of_operation_wednesday: location.hours.wednesday.text,
    latitude: location.geo.latitude.toFixed(6).toString(),
    location_address: location.geo.street,
    location_id: location.slug,
    location_phone: location.phone,
    longitude: location.geo.longitude.toFixed(6).toString(),
    name: location.name,
    request_service_link: '',
    slug: location.slug,
    start_your_rental_link: '',
    state: location.geo.region ?? location.geo.state,
    state_name:
      getStateFullName(location.geo.region ?? location.geo.state, USStates) ??
      location.geo.region ??
      location.geo.state,
    zip_code: location.geo.postal_code,
    _id: '',
  };

  return {
    branch_id: market.market_id,
    latlon_detail: {
      delivery_available: true,
      distance_miles: location.geo.distance_miles.toFixed(2),
    },
    rental_service_slug: rentalService.slug,
    rental_service_name: rentalService?.name || '',
    rental_service_rich_text_content: rentalService?.rich_text_content || '',
    location: branchLocation,
  };
};
